import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconUpgradeFilledSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M7.31 13.488V9.037C7.31 4.047 11.33 0 16.29 0c4.959 0 8.98 4.046 8.98 9.037v4.451h2.245c.87 0 1.575.708 1.575 1.585v15.342c0 .877-.704 1.585-1.575 1.585H5.065a1.58 1.58 0 0 1-1.575-1.585V15.073c0-.877.703-1.585 1.574-1.585zm13.47 0V9.037c0-2.495-2.01-4.519-4.49-4.519S11.8 6.542 11.8 9.037v4.451zm-4.488 11.903a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.334" clipRule="evenodd" /></svg>;
export default SvgIconUpgradeFilledSmall;